module.exports = {
  messages: {
    CAREER_HUB_BACK_BUTTON: 'Zurück',
    CAREER_HUB_EVERGREEN_BACK_BUTTON: 'Zur Übersicht',
    CAREER_HUB_FOOTER_BODYCOPY:
      'Einfach ein paar Suchkriterien ausfüllen und Filter setzen. Und schon sparst Du Dir langes Suchen und Scrollen. ',
    CAREER_HUB_FOOTER_BUTTON: 'Jetzt loslegen',
    CAREER_HUB_FOOTER_HEADLINE: 'Starte jetzt Deine Job-Suche.',
    CAREER_HUB_GLOSSARY_HEADLINE_DESCRIPTION:
      'Per Klick auf die Buchstaben suchst Du gezielt nach Stichworten, Themen und Artikeln. Oder Du lässt Dich einfach nur inspirieren.',
    CAREER_HUB_GLOSSARY_HEADLINE_TITLE: 'News nach Stichworten sortiert',
    CAREER_HUB_GLOSSARY_PAGE_TITLE: 'Glossar',
    CAREER_HUB_GLOSSARY_TITLE: 'Wo möchtest Du suchen?',
    CAREER_HUB_HOME_HEADER_ALT:
      'Zwei Arbeitskolleginnen sprechen im Büro miteinander.',
    CAREER_HUB_HOME_HEADER_HEADLINE: 'Der XING Karriere-Ratgeber',
    CAREER_HUB_HOME_HEADER_SUBLINE:
      "Die besten Artikel, Tipps von erfahrenen Profis und Insider·innen sowie Erfolgsgeschichten zum Nachmachen. Von der XING Redaktion recherchiert und kuratiert, damit's in Deinem Berufs-Leben immer rund läuft.",
    CAREER_HUB_HOME_MORE_BUTTON: 'Alle Infos ansehen',
    CAREER_HUB_HOME_TITLE: 'Karriere-Ratgeber',
    CAREER_HUB_LOGOUT_FOOTER_SERVICES: 'Services von XING',
    CAREER_HUB_LOGOUT_FOOTER_TOPICS: 'Topics',
    CAREER_HUB_META_DESCRIPTION:
      'Ganz gleich ob Du noch studierst oder schon viel Berufserfahrung hast ➤ Im XING Karriere-Ratgeber findest Du hilfreiche Informationen zu Gehalt, Bewerbung oder Karriere!',
    CAREER_HUB_META_TITLE: 'Der XING Karriere-Ratgeber ▷ Mach Dein XING',
    CAREER_HUB_REGISTER_BANNER_BUTTON: 'Jetzt kostenlos registrieren',
    CAREER_HUB_REGISTER_BANNER_HEADER: 'Deine Interessen, Deine Artikel',
    CAREER_HUB_REGISTER_BANNER_SUBLINE:
      'Alle wichtigen Branchen, handverlesene Artikel und Expert·innen, die bei Themen wie Jobs und Arbeitsleben nicht fehlen dürfen. Deinen täglichen News-Mix gibt’s hier.',
    CAREER_HUB_SUBTOPIC_PAGE_ANSCHREIBEN_DESCRIPTION:
      'Tipps zum Anschreiben bei XING. Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Tipps zum Anschreiben.',
    CAREER_HUB_SUBTOPIC_PAGE_ANSCHREIBEN_TITLE:
      'Tipps zum Arbeitszeugnis | Der XING Karriere-Ratgeber',
    CAREER_HUB_SUBTOPIC_PAGE_BESONDERE_DESCRIPTION:
      'Besondere Bewerbung bei XING. Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Besondere Bewerbung.',
    CAREER_HUB_SUBTOPIC_PAGE_BESONDERE_TITLE:
      'Besondere Bewerbung | Der XING Karriere-Ratgeber',
    CAREER_HUB_SUBTOPIC_PAGE_BEWERBUNGSARTEN_DESCRIPTION:
      'Bewerbungsarten und Formate bei XING. Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Bewerbungsarten und Formate.',
    CAREER_HUB_SUBTOPIC_PAGE_BEWERBUNGSARTEN_TITLE:
      'Bewerbungsarten und Formate | Der XING Karriere-Ratgeber',
    CAREER_HUB_SUBTOPIC_PAGE_LEBENSLAUF_DESCRIPTION:
      'Tipps zum Lebenslauf bei XING: Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Tipps zum Lebenslauf.',
    CAREER_HUB_SUBTOPIC_PAGE_LEBENSLAUF_TITLE:
      'Tipps zum Lebenslauf | Der XING Karriere-Ratgeber',
    CAREER_HUB_SUBTOPIC_PAGE_VORSTELLUNGSGESPRACH_DESCRIPTION:
      'Tipps zum Vorstellungsgespräch bei XING: Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Tipps zum Vorstellungsgespräch.',
    CAREER_HUB_SUBTOPIC_PAGE_VORSTELLUNGSGESPRACH_TITLE:
      'Tipps zum Vorstellungsgespräch | Der XING Karriere-Ratgeber',
    CAREER_HUB_TOPIC_CAROUSEL_DESCRIPTION:
      'Artikel mit speziellen Schwerpunkte, hilfreichen Tipps und mehr:',
    CAREER_HUB_TOPIC_CAROUSEL_TITLE: 'Lese-Tipps zu diesem Thema',
    CAREER_HUB_TOPIC_PAGE_ARBEITSRECHT_DESCRIPTION:
      'Als Arbeitnehmer hast Du Rechte, auch bei einer Kündigung. Erfahre, was Dein Chef darf und was nicht – und wie Du Dich wehren kannst.',
    CAREER_HUB_TOPIC_PAGE_ARBEITSRECHT_TITLE:
      'Arbeitsrecht: Deine Rechte & Pflichten als Arbeitnehmer | XING',
    CAREER_HUB_TOPIC_PAGE_BEWERBUNG_DESCRIPTION:
      'Mit einem überzeugenden Anschreiben, einem aussagekräftigen Lebenslauf und ein paar wertvollen Tipps für eine erfolgreiche Bewerbung wirst Du zum Traumkandidaten für jeden Arbeitgeber. Jetzt den Traumjob sichern!',
    CAREER_HUB_TOPIC_PAGE_BEWERBUNG_TITLE:
      'Bewerbungstipps – So überzeugst Du jeden Arbeitgeber | XING',
    CAREER_HUB_TOPIC_PAGE_BEWERBUNG_UEBERSICHT_DESCRIPTION:
      'Bewerbung bei XING. Bei uns finden Sie ✓ Tipps und ✓ Tricks zum Thema ► Bewerbung.',
    CAREER_HUB_TOPIC_PAGE_BEWERBUNG_UEBERSICHT_TITLE:
      'Bewerbung | Der XING Karriere-Ratgeber',
    CAREER_HUB_TOPIC_PAGE_FRAU_DESCRIPTION:
      'Erfahre, wie Frauen in Führungspositionen Kind und Karriere unter einen Hut bringen können. Lerne von erfolgreichen Vorbildern und starte Deine eigene Erfolgsgeschichte!',
    CAREER_HUB_TOPIC_PAGE_FRAU_TITLE:
      'Frauen in Führungspositionen – Karriere und Familie vereinbaren | XING',
    CAREER_HUB_TOPIC_PAGE_FUHRUNG_DESCRIPTION:
      'Entdecke, wie Du mit den richtigen Soft Skills Deine Führungskompetenz stärkst, Deine Karriere vorantreibst und Deine Mitarbeiter·innen motivierst. Klicke jetzt für wertvolle Tipps und Tricks!',
    CAREER_HUB_TOPIC_PAGE_FUHRUNG_TITLE:
      'Führung & Management erfolgreich meistern | XING',
    CAREER_HUB_TOPIC_PAGE_GEHALT_DESCRIPTION:
      'Erfahre, wie Du Deine Gehaltsverhandlung erfolgreich meisterst und mit unseren Verhandlungstipps in Deiner Bewerbung punktest. Jetzt klicken und durchstarten!',
    CAREER_HUB_TOPIC_PAGE_GEHALT_TITLE:
      'Gehaltsverhandlung: Die besten Tipps für Deine Bewerbung | XING',
    DESCRIPTION_CARD_1_CAREER_HUB: 'Falls Du zu Hause am besten bist.',
    DESCRIPTION_CARD_2_CAREER_HUB: 'Arbeite doch einfach, wann Du willst.',
    DESCRIPTION_CARD_3_CAREER_HUB: 'Schau mal, was für Dich möglich ist.',
    DESCRIPTION_CARD_4_CAREER_HUB:
      'Hier werden Deine Gehaltsvorstellungen übertroffen.',
    DESCRIPTION_CARD_5_CAREER_HUB: 'Damit noch Zeit für anderes bleibt.',
    DESCRIPTION_CARD_6_CAREER_HUB: 'Falls Du erstmal klein anfangen willst.',
    EP_ERROR_BODY:
      'Vielleicht klappt\'s wieder, wenn Du auf "Aktualisieren" klickst.',
    EP_ERROR_HEADER: 'Warum ist hier denn nichts zu sehen?',
    GLOBAL_GENERIC_ERROR_BUTTON: 'Nochmal versuchen',
    GLOBAL_GENERIC_ERROR_DESCRIPTION: "Dann versuch's einfach nochmal.",
    MOVEON_GENERIC_ERROR_CTA: 'Nochmal versuchen',
    TITLE_CARD_1_CAREER_HUB: 'Jobs mit Remote-Optionen',
    TITLE_CARD_2_CAREER_HUB: 'Jobs mit flexiblen Arbeitszeiten',
    TITLE_CARD_3_CAREER_HUB: 'Jobs als Quereinsteiger·in',
    TITLE_CARD_4_CAREER_HUB: 'Jobs mit Top-Bezahlung',
    TITLE_CARD_5_CAREER_HUB: 'Jobs in Teilzeit',
    TITLE_CARD_6_CAREER_HUB: 'Mini-Jobs',
  },
};
